import { render, staticRenderFns } from "./TemporarilyWaiterListTab.vue?vue&type=template&id=3c19278a&scoped=true&lang=pug"
import script from "./TemporarilyWaiterListTab.vue?vue&type=script&lang=ts"
export * from "./TemporarilyWaiterListTab.vue?vue&type=script&lang=ts"
import style0 from "./TemporarilyWaiterListTab.vue?vue&type=style&index=0&id=3c19278a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19278a",
  null
  
)

export default component.exports